// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  font-size: 52px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: #6060ab;
  font-weight: 500;
}

.arrow {
  text-align: left;
}

.entry {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.tool-card {
  width: 560px;
  height: 220px;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(45deg, #acb6e5 10%, #86fde8 100%);
  border-radius: 10px;
  padding: 3px 3px;
}

.content {
  width: 554px;
  height: 213px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border-radius: 8px;
  padding: 25px 40px;
}

.btn {
  margin-top: 6px;
  background-color: #39393b;
  border: 1px solid #39393b;
  padding-top: 2px;
  padding-bottom: 2px;
  cursor: pointer;
}

.btn:hover {
  background-color: #6060ab;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
  transition-duration: 0.3s;
}

.tool-icon {
  font-size: 38px;
  margin-left: 15px;
  display: inline-block;
  color: #1f1f1f;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/aac-tools/aac-tools.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,+EAAA;EAEA,yBAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;AAAF","sourcesContent":[".heading {\n  font-size: 52px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  color: #6060ab;\n  font-weight: 500;\n}\n\n.arrow {\n  text-align: left;\n}\n\n.entry {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.tool-card {\n  width: 560px;\n  height: 220px;\n  margin-left: auto;\n  margin-right: auto;\n  background: linear-gradient(45deg, #acb6e5 10%, #86fde8 100%);\n  border-radius: 10px;\n  padding: 3px 3px;\n}\n\n.content {\n  width: 554px;\n  height: 213px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: white;\n  border-radius: 8px;\n  padding: 25px 40px;\n}\n\n.btn {\n  margin-top: 6px;\n  background-color: #39393b;\n  border: 1px solid #39393b;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  cursor: pointer;\n}\n\n.btn:hover {\n  background-color: #6060ab;\n  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24),\n    0 17px 50px 0 rgba(0, 0, 0, 0.19);\n  transition-duration: 0.3s;\n}\n\n.tool-icon {\n  font-size: 38px;\n  margin-left: 15px;\n  display: inline-block;\n  color: #1f1f1f;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
